<template>
  <div
    style=" position: fixed;
  top: 8vw;
  left: 0;
  width: 100%;
  z-index: 10;
  height: 5rem;"
  >
    <div class="my-outbox1">
      <div class="my-inbox1" ref="box">
        <div class="msgDanmu" id="danmu">
          <div class="memory-msg-item " v-for="(item, index) in msg" :key="index">
            <div class="item-user">
              <img class="headimg" :src="item.img" />
              <div class="name">
                <span class="name">{{ item.nicheng }}</span>
                <span class="name1" :style="getColor()">：{{ item.con }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-marquee-left',
  props: ['msg', 'jntTemplateId'],
  data() {
    return {}
  },
  methods: {
    getColor() {
      let _css = 'color: #ffffff;'
      if (this.jntTemplateId == 2 || this.jntTemplateId == 3 || this.jntTemplateId == 5) {
        _css = 'color: #333333;'
      }
      return _css
    },
  },
  mounted: function() {
    setTimeout(() => {
      var target = this.$refs.box
      var initLeft = 0
      setInterval(function() {
        initLeft++
        if (initLeft >= target.offsetWidth / 2) {
          initLeft = 0
        }
        target.style = 'transform: translateX(-' + initLeft + 'px)'
      }, 30)
    }, 500)
  },
}
</script>

<style>
.my-outbox1 {
  color: #ffffff;
  overflow: hidden;
  height: 2.5rem;
  margin-top: 0.9rem;
  position: relative;
  width: 33rem;
  margin-left: 2rem;
}
.my-inbox1 {
  white-space: nowrap;
  position: absolute;
  font-size: 0;
  height: 3rem;
  width: 30rem;
}
.my-list1 {
  margin-right: 25px;
  display: inline-block;
  font-size: 13px;
  height: 35px;
  line-height: 35px;
}
.my-uname1 {
  color: #ff8900;
}
.memory-msg-list {
  position: fixed;
  top: 3.7rem;
  left: 0;
  width: 100%;
  z-index: 10;
  height: 5rem;
}

.my-outbox1 .danmu {
  display: table-cell;
}

.my-outbox1 .memory-msg-item {
  float: none;
  white-space: nowrap;
  display: table-cell;
  padding-right: 2rem;
}

.my-outbox1 .memory-msg-item * {
  vertical-align: middle;
}

.memory-msg-item .item-user .name {
  color: #f1a524;
  float: none;
  display: inline-block;
  font-size: 0.9rem;
  padding-left: 0.3rem;
}

.memory-msg-item .item-user .headimg {
  height: 1.1rem;
  width: 1.1rem;
  float: none;
  display: inline-block;
  background-size: 100%;
  border: 1px solid #e4803c;
  background-repeat: no-repeat;
  border-radius: 50%;
  box-sizing: border-box;
  position: relative;
  top: 1px;
}

.my-outbox1 .memory-msg-item p {
  float: none;
  display: inline-block;
  font-size: 1.2rem;
  color: #3c3c3c;
  padding-top: 0.3rem;
}

.my-outbox1 .memory-msg-item i {
  height: 30px;
  float: none;
  display: inline-block;
}

.memory-msg-text1 {
  position: absolute;
  top: -15%;
}

.memory-msg-text2 {
  position: absolute;
  top: 32%;
}

.memory-msg-text3 {
  position: absolute;
  top: 40%;
}

.memory-msg-text4 {
  position: absolute;
  top: 60%;
}
</style>
